(function () {
  if (window.__mb10) { window.__mb10(); return; }
  // Oferta personal de 15 minutos: parte la primera vez que la persona entra a la faja 2x1,
  // no se reinicia al recargar y, al llegar a cero, el 2x1 deja de estar disponible para ella.
  var KEY = 'mb_faja2x1_start', DUR = 15 * 60 * 1000, mem = null;
  function read() {
    try { var v = parseInt(window.localStorage.getItem(KEY), 10); return isNaN(v) ? mem : v; } catch (e) { return mem; }
  }
  function write(v) { mem = v; try { window.localStorage.setItem(KEY, String(v)); } catch (e) {} }
  function two(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var design = !!(window.Shopify && Shopify.designMode);
    var onOffer = !!document.querySelector('[data-mb-2x1-page]');
    var start = read();
    if (start === null && onOffer) { start = Date.now(); write(start); }
    var left = start === null ? 0 : Math.max(0, Math.ceil((start + DUR - Date.now()) / 1000));
    if (design && left <= 0) left = DUR / 1000;
    var running = left > 0;
    document.querySelectorAll('[data-mb-10min]').forEach(function (el) {
      el.hidden = !running;
      var m = el.querySelector('[data-u="m"]'), s = el.querySelector('[data-u="s"]');
      if (m) m.textContent = two(Math.floor(left / 60));
      if (s) s.textContent = two(left % 60);
    });
    document.documentElement.classList.toggle('mb-2x1-expired', onOffer && !running && !design);
  }
  window.__mb10 = tick;
  tick();
  setInterval(tick, 1000);
})();
